import { render, staticRenderFns } from "./TextTooltip.vue?vue&type=template&id=6fd9f0b8&scoped=true"
import script from "./TextTooltip.vue?vue&type=script&lang=js"
export * from "./TextTooltip.vue?vue&type=script&lang=js"
import style0 from "./TextTooltip.vue?vue&type=style&index=0&id=6fd9f0b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd9f0b8",
  null
  
)

export default component.exports